import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import "jspdf-autotable";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class TermDetails extends React.Component {
  static contextType = FilterContext;

  state = {
    termDetails: [],
    filters: "",
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_custom_term_details", BodyAsFormData(filters))
      .then((res) => {
        this.setState({ termDetails: res.data });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_custom_term_details",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ termDetails: res.data });
        });
    }
  }

  render() {
    return (
      <div className="container-fluid unitsRents">
        <div className="row">
          <div className="col-lg-12">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Period</th>
                  <th>Moratorium Period</th>
                  <th>Rent (₹)</th>
                  <th>Rent (₹/sqft/month)</th>
                  <th>Fitout Rent (₹/sqft/month)</th>
                  <th>Rent Escalation (%)</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(this.state.termDetails).length > 0 &&
                  Object.keys(this.state.termDetails).map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{this.state.termDetails[item].start_date}</td>
                        <td>{this.state.termDetails[item].end_date}</td>
                        <td>{this.state.termDetails[item].period}</td>
                        <td>
                          {this.state.termDetails[item].moratorium_period}
                        </td>
                        <td>{this.state.termDetails[item].rent}</td>
                        <td>{this.state.termDetails[item].rent_int}</td>
                        <td>{this.state.termDetails[item].fitout_rent_sft}</td>
                        <td>{this.state.termDetails[item].rent_escalation}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(TermDetails);
